exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-inventory-products-adjust-quantity .modal-dialog{width:250px}", ""]);

// exports
